import { apiRequestCall } from 'app/services/api';
import { ApiResource } from 'app/services/api/enums';
import { CancelToken } from 'axios';
import { AutoSwapSettingDto } from 'app/interfaces/dto';

export const saveAutoSwapSetting = ({
  cancelToken,
  ...data
}: AutoSwapSettingDto & { cancelToken: CancelToken }) => {
  return apiRequestCall<AutoSwapSettingDto>({
    params: {
      method: 'PUT',
      resource: ApiResource.Payments,
      urlPrefix: 'users/auto-swaps',
      cancelToken,
      data,
    },
  });
};
